import React, { useEffect, useState } from "react";
import Auctions from "../../components/ipillion/Auctions";
import Fintech from "../../components/assets/ez_credit/Fintech";
import Header from "../../components/projects/ezcredit/sections/Header";
// import Facts from "../../components/ez_credit/Facts";
import What_ez from "../../components/ez_credit/What_ez";
import Community from "../../components/projects/ezcredit/sections/Community";
import How_work from "../../components/ez_credit/How_work";
import Image from "next/image";
// import BankSlider from "../../components/projects/ezcredit/sections/BankSlider";
import { useRouter } from "next/router";
import TechSlider from "../../components/projects/ezcredit/sections/TechSlider";
import WhyEz from "../../components/projects/ezcredit/sections/WhyEz";
import axios from "axios";
import SectionTitle from "../../components/SectionTitle";
import ProjectsComp from "../../components/projects";
import Head from "next/head";
import { useTranslations } from "next-intl";

const ezcredit = () => {
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  useEffect(() => {
    setLang(router.locale);
  }, [router.locale]);
  const [allProjects, setAllProjects] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.NEXT_APP_BACKEND_URL}user/project/all-Project`)
      .then((res) => {
        setAllProjects(res.data.result.slice(0, 1));
      })
      .catch((err) => {
      });
  }, []);
  const t = useTranslations("ez_credit");

  return (
    <>
      <Head>
        <title>Ascot - EZ Credit</title>
      </Head>
      <div className="bg-[#F2F2F2]" key={lang}>
        <div className={`absolute z-0 h-[873px] hidden lg:block `}>
          <div
            className={`absolute h-[758px] w-screen ${
              lang == "ar" ? "-scale-x-100" : null
            } `}
          >
            <Image src={"/projects/Ezcredit/intersect2.png"} layout="fill" />
          </div>
          <div
            className={`absolute h-[709px] w-screen ${
              lang == "ar" ? "-scale-x-100" : null
            }`}
          >
            <Image src={"/projects/Ezcredit/intersect1.png"} layout="fill" />
          </div>
        </div>
        <div className="absolute z-0 h-[873px] lg:hidden block">
          <div className="absolute h-[302px] bottom-10 w-screen">
            <Image src={"/projects/Ezcredit/Myellow.png"} layout="fill" />
          </div>
          <div className="absolute h-[809px] w-screen">
            <Image src={"/projects/Ezcredit/Mblue.png"} layout="fill" />
          </div>
        </div>
        <div className="max-w-[90rem] responsive mx-auto relative">
          <Header />
        </div>
        <div className="max-w-[90rem] m-auto responsive ">
          <div className="mt-28 relative">
            <Auctions
              text={t("fintech")}
              icon={<Fintech />}
              color={"#C29D3E"}
              link={"/services/64070944703e2f89a5b9ba33"}
            />
          </div>
        </div>
        <div className="mb-20" key={"BankSlider"}>
          {/* <BankSlider /> */}
        </div>
        <div className="max-w-[90rem] m-auto responsive ">
          <What_ez />
        </div>
        <div key={"TechSlider"}>
          <TechSlider />
        </div>
        <div>
          <WhyEz />
        </div>
        <div className="max-w-[90rem] m-auto responsive ">
          <How_work />
          {/* <Facts /> */}
        </div>
        <Community />
        <div className="py-24">
          <SectionTitle title={t("discover")} />
          <ProjectsComp data={allProjects} />
        </div>
      </div>
    </>
  );
};

export default ezcredit;

export async function getStaticProps({ locale }) {
  return {
    props: {
      messages: require(`../../locales/${locale || "en"}.json`),
    },
  };
}
